<template lang="pug">
    section
        .content-status-flex-row
            .content-status-flex-col.datepickers
                el-row(:gutter="20")
                    el-col(:span="8")
                        el-form-item.is-full-width(:label="$t('Created at')" prop="created_at")
                            el-date-picker.is-full-width(
                                v-model="createdAt"
                                type="datetime"
                                :format="$t('yyyy-MM-dd') + ' HH:mm'"
                                prefix-icon="far el-icon-fa-calendar-alt"
                                :picker-options="{firstDayOfWeek:1, disabledDate: disabledPublishStartDate}"
                            )
                    el-col(:span="8")
                        el-form-item.is-full-width(:label="$t('Publish start')" prop="publish_start")
                            el-date-picker.is-full-width(
                                v-model="publishStart"
                                type="date"
                                :format="$t('yyyy-MM-dd')"
                                prefix-icon="far el-icon-fa-calendar-alt"
                                :picker-options="{firstDayOfWeek:1, disabledDate: disabledPublishStartDate}"
                            )
                    el-col(:span="8")
                        el-form-item.is-full-width(:label="$t('Publish end')" prop="publish_end")
                            el-date-picker.is-full-width(
                                v-model="publishEnd"
                                type="date"
                                :format="$t('yyyy-MM-dd')"
                                prefix-icon="far el-icon-fa-calendar-alt"
                                :picker-options="{firstDayOfWeek:1, disabledDate: disabledPublishEndDate}"
                            )
                    el-col(:span="8")
                        .restriction-row(v-if="enabledExtensions.includes('restricted-area')")
                            el-form-item(:label="$t('Accessible by')" prop="restriction")
                                el-select.is-full-width(placeholder="" v-model="restriction")
                                    el-option(
                                        v-for="restriction in restrictions"
                                        :key="restriction.key"
                                        :label="restriction.name"
                                        :value="restriction.value"
                                    )
            .content-status-flex-col.status-switch
                el-form-item
                    el-switch(
                        :active-text="$t('Active')"
                        inactive-color="#ff4949"
                        v-model="status"
                    )
        // el-form-item(:label="$t('Publish from / to')" prop="publish")
            el-date-picker(
                type="datetimerange"
            )

        el-form-item(:label="$t('Page Type')" prop="view")
            el-select.is-full-width(
                disabled
                placeholder="" v-model="view" valueKey="view"
            )
                el-option(v-for="item in options.view.items" :key="item.value" :label="item.name" :value="item.value")

        el-form-item(:label="$t('Category')" prop="category")
            el-select.is-full-width(
                placeholder="" v-model="category" valueKey="key"
                :class="{ 'loading': options.category.loading }"
            )
                el-option(v-for="item in options.category.items" :key="item.id" :label="item.name" :value="item")

        el-form-item(:label="tags.length ? $t('Tags') : ''" prop="tags")
            el-tag(
                v-for="tag in tags"
                closable
                :key="tag.name"
                size="large"
                @close="removeTag(tag)"
            ) {{ tag.name }}
            el-autocomplete.input-new-tag(
                v-if="newTagInputVisible"
                v-model="newTagInput"
                ref="newTagInput"
                size="small"
                value-key="name"
                :fetch-suggestions="autocompleteTag"
                :placeholder="$t('Add tag')"
                @select="selectExistingTag"
                @keydown.escape.native="resetNewTag"
                @keydown.enter.native.prevent="addNewTag"
                @clear="resetNewTag"
                @blur="blurNewTag"
                :maxlength="255"
                show-word-limit
            )
            el-button.button-new-tag(
                v-else
                type="primary"
                icon="el-icon-fa-plus fas"
                size="large"
                @click="showTagInput"
            ) {{ $t('Add tag') }}
</template>

<i18n>
{
    "de": {
        "Created at": "Erstellt am",
        "Category": "Kategorie",
        "Page Type": "Seitentyp",
        "Everybody": "Jedem",
        "Members": "Mitgliedern",
        "Guests": "Gästen",
        "Accessible by": "Zugänglich von",
        "Tags": "Tags",
        "Add tag": "Tag hinzufügen"
    }
}
</i18n>

<script>

import _ from 'lodash'
import Fuse from 'fuse.js'
import { compareAsc, compareDesc, addDays, startOfDay, fromUnixTime, getUnixTime } from 'date-fns'
import { mapGetters, mapMutations, mapActions } from 'vuex'


import store from '@/store'

export default {
    name: 'Settings',
    data() {
        return {
            newTagInputVisible: false,
            newTagInput: '',
            // tags: [
            //     { name: 'inventore' },
            //     { name: 'architecto' },
            // ]
        };
    },
    computed: {
        restrictions() {
            return [
                {
                    key: 'everybody',
                    value: null,
                    name: this.$t('Everybody')
                },
                {
                    key: 'members',
                    value: 'members',
                    name: this.$t('Members')
                },
                {
                    key: 'guests',
                    value: 'guests',
                    name: this.$t('Guests')
                }
            ]
        },
        status: {
            get() {
                let enabled = true

                const start = this.publishStart
                if (start && enabled) enabled = compareAsc(new Date(), start) > 0

                const end = this.publishEnd
                // if (end && enabled) enabled = compareDesc(new Date(), addDays(end, 1)) > 0
                if (end && enabled) enabled = compareDesc(new Date(), end) > 0

                return enabled
            },
            set(active) {

                const start = this.publishStart
                const end = this.publishEnd

                if (active) {
                    if (start && compareAsc(new Date(), start) < 0) this.publishStart = startOfDay(new Date())
                    else if (end && compareDesc(new Date(), end) < 0) this.publishEnd = null
                } else {
                    this.publishEnd = startOfDay(new Date())
                }
            }
        },
        createdAt: {
            get() {
                let createdAt =  _.get(this.form, 'created_at')
                if (createdAt) createdAt = fromUnixTime(createdAt)
                return createdAt
            },
            set(value) {
                const createdAt = value !== null ? getUnixTime(value) : null
                store.commit('page/form/createdAt', createdAt)
            }
        },
        publishStart: {
            get() {
                const start =  _.get(this.form, 'publish_start')
                return start ? startOfDay(fromUnixTime(start)) : ''
            },
            set(value) {
                const start = value !== null ? getUnixTime(value) : null
                store.commit('page/form/publishStart', start)
            }
        },
        publishEnd: {
            get() {
                const end = _.get(this.form, 'publish_end')
                return end ? startOfDay(fromUnixTime(end)) : ''
            },
            set(value) {
                const end = value !== null ? getUnixTime(value) : null
                store.commit('page/form/publishEnd', end)
            }
        },
        category: {
            get() {
                return _.get(this.form, 'category')
            },
            set(value) {
                store.commit('page/form/category', value)
            }
        },
        view: {
            get() {
                return _.get(this.form, 'view')
            },
            set(value) {
                store.commit('page/form/view', value)
            }
        },
        restriction: {
            get() {
                return _.get(this.form, 'restriction');
            },
            set(value) {
                store.commit('page/form/restriction', value);
            }
        },
        autocompleteTagOptions() {
            let options = this.options.tag.items
            return options.filter(option => {
                return ! this.tags.find(tag => tag.name === option.name)
            })
        },
        tags() {
            return _.get(this.form, 'tags') || []
        },
        ...mapGetters({
            form: 'page/form',
            options: 'page/options',

            // cms
            activeCms: 'activeCms',
            enabledExtensions: 'enabledExtensions'
        }),
    },
    methods: {
        disabledPublishStartDate(start) {
            const end = this.publishEnd
            if (end) return compareAsc(addDays(start, 1), end) > 0
            else return false
        },
        disabledPublishEndDate(end) {
            const start = this.publishStart
            if (start) return compareDesc(end, addDays(start, 1)) > 0
            else return false
        },
        showTagInput() {
            this.newTagInputVisible = true
            this.$nextTick(() => {
                this.$refs.newTagInput.$refs.input.focus()
            })
        },
        addNewTag() {
            this.addTag(this.newTagInput);
            this.resetNewTag();
            this.$nextTick(this.showTagInput);
        },
        resetNewTag() {
            this.newTagInputVisible = false
            this.newTagInput = ''
        },
        blurNewTag() {
            // setTimeout(() => {
            //     if (this.$refs.newTagInput && this.$refs.newTagInput.$refs.input.focused === false) this.resetNewTag();
            // }, 150);

            setTimeout(() => {
                if (this.$refs.newTagInput && this.$refs.newTagInput.$refs.input.focused === false) this.addTag(this.newTagInput);
                this.resetNewTag();
            }, 150);
        },
        autocompleteTag(query, callback) {
            if (! this.autocompleteTagOptions.length || ! query) {
                callback([])
                return false
            }

            const settings = {
                shouldSort: true,
                tokenize: true,
                matchAllTokens: true,
                threshold: 0.3,
                minMatchCharLength: 1,
                keys: ['name'],
            }
            const fuse = new Fuse(this.autocompleteTagOptions, settings)
            const result = _.map(fuse.search(query), el => {
                return el.item
            })
            callback(result)
        },
        selectExistingTag(tag) {
            this.addTag(tag.name);
            this.resetNewTag();
            this.$nextTick(this.showTagInput);
        },
        ...mapMutations({
            addTag: 'page/form/addTag',
            removeTag: 'page/form/removeTag',
        })
    }
}
</script>

<style lang="sass" scoped>
    section.category-page-form > .el-form-item:last-child
        margin-bottom: 0

    .el-tag
        vertical-align: middle
        & + .button-new-tag,
        & + .input-new-tag
          margin-left: 10px

    .button-new-tag
        min-width: 160px
        height: 32px
        line-height: 30px
        padding-top: 0
        padding-bottom: 0
        vertical-align: middle

    .input-new-tag
        /* width: 160px */
        width: 220px
        height: 32px
        line-height: 30px
        vertical-align: middle

    .tag-row .el-form-item
        margin-bottom: 0
</style>
